import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoRankingMethodSelector.css';

const VideoRankingMethodSelector = ({ rankingMethod, onRankingMethodChange }) => {
  const { t } = useTranslation(['discovery']);

  const rankingMethods = [
    { id: 'views', name: t('videoDiscovery.rankingMethod.views') },
    { id: 'likes', name: t('videoDiscovery.rankingMethod.likes') },
    { id: 'comments', name: t('videoDiscovery.rankingMethod.comments') },
    { id: 'engagement', name: t('videoDiscovery.rankingMethod.engagement') },
  ];

  const handleRankingMethodChange = (event) => {
    onRankingMethodChange(event.target.value);
  };

  return (
    <div className="video-ranking-method-selector">
      <select
        id="ranking-method"
        className="video-ranking-method-selector__select"
        value={rankingMethod}
        onChange={handleRankingMethodChange}
      >
        {rankingMethods.map((method) => (
          <option key={method.id} value={method.id}>
            {method.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default VideoRankingMethodSelector;